import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.8@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-stUp",
  "use": "icon-stUp-usage",
  "viewBox": "0 0 12 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 12 14\" id=\"icon-stUp\">\n  <image id=\"icon-stUp_上_策略\" width=\"12\" height=\"14\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAOCAYAAAAbvf3sAAAAaElEQVQokWP8//8/AxbQARWqwJACaUDDHf8RAMRGkcenGAY6cGmoxFCKAJXoGiowlGCCCpgGYhTDQAUolBSQwiCJgYGhFi1cmhkYGObBOCwMDAwPkCTfYQQjRAyuhglDmgAYeRoYGBgAjdvi6SImmuIAAAAASUVORK5CYII=\"></image>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol